/* eslint-disable custom/no-unsafe-deep-access */
import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { ButtonWithIcon } from '@els/els-react--button';
import { Card } from '@els/els-react--card';

function DocumentIndexTerms({ keywords, closeClick }) {
  const handleClose = () => {
    const event = new CustomEvent('documentSectionClosed', {
      detail: { closedSection: 'indextermsExpanded', focusNext: true },
    });
    document.dispatchEvent(event);
    closeClick();
  };

  return (
    <Card
      data-section="indextermsExpanded"
      id="indextermsExpanded-content"
      tabIndex="-1"
      role="region"
      aria-labelledby="indextermsExpanded-heading"
      className="result-detail-panel u-els-margin-top-1o2">
      <div className="result-detail-panel-wrapper u-els-display-flex">
        <h4 id="indextermsExpanded-heading" className="u-els-margin-right-1o2 u-els-font-family-bold">
          Index Terms:
        </h4>
        <div className="u-els-display-flex u-els-margin-right-2x">
          <div className="u-els-font-size-base u-els-line-height-default">
            {keywords.map((keyword) => (
              <div key={keyword.type}>
                <b>{keyword.type}: </b>
                {keyword.value &&
                  keyword.value?.map((value) => (
                    <React.Fragment key={value}>
                      <InnerHTML tag="span" html={value} />
                      {keyword.value?.indexOf(value) !== keyword.value.length - 1 && <span className="separator" />}
                    </React.Fragment>
                  ))}
              </div>
            ))}
          </div>
          <ButtonWithIcon
            data-e2e="e2e-index-terms-close"
            type="link"
            iconOnly
            linkIconSize="s"
            linkOptions={['navigation']}
            sprite="Close"
            className="result-detail-panel-wrapper-close e2e-close"
            data-automationid="sub-menu-close"
            onClick={handleClose}>
            close
          </ButtonWithIcon>
        </div>
      </div>
    </Card>
  );
}

DocumentIndexTerms.propTypes = {
  keywords: PropTypes.array.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentIndexTerms;
